const selectCountry = state => {
  const ipCountry = state.app.ipCountry;
  const countries = state.content.config.data?.find(c => c.key === 'countries')
    ?.value;

  return countries?.find(c => c.value === ipCountry);
};

export default selectCountry;
